import React from 'react';

// import PropTypes from 'prop-types';
import s from './ButtonSecondary.module.scss';
import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames';

const ButtonSecondary = ({
  borderColor = 'white',
  asLink = false,
  children,
  disabled,
  size,
  icon,
  onClick,
  openInNewTab = false,
  modifiers = [],
  isToggle = false,
  isActive = false,
  animateIcon = false,
  ...props
}) => {
  const rootClasses = classNames(
    s.Root,
    {
      [s.BorderWhite]: borderColor === 'white',
      [s.BorderBlack]: borderColor !== 'white',
      [s.Disabled]: !!disabled,
      [s.Small]: size === 'small',
      [s.Xsmall]: size === 'xsmall',
      [s.Active]: isActive,
      [s.Toggle]: isToggle,
      [s.AnimateIcon]: animateIcon,
    },
    modifiers.map((m) => s[m])
  );
  return asLink ? (
    <Link
      {...props}
      onClick={onClick}
      target={openInNewTab && '_blank'}
      className={rootClasses}>
      <i className={s.Bg} aria-hidden={true} />
      {icon && (
        <span className={s.IconWrapper}>
          <Image
            width={22}
            height={22}
            src={`/img/${icon}.svg`}
            alt=""
            className={classNames(s.Icon, s.IconDefault)}
          />
          <Image
            width={22}
            height={22}
            src={`/img/${icon}.svg`}
            alt=""
            className={classNames(s.Icon, s.IconHover)}
          />
        </span>
      )}
      {children}
    </Link>
  ) : (
    <button type="button" className={rootClasses} onClick={onClick} {...props}>
      <i className={s.Bg} aria-hidden={true} />
      {icon && (
        <span className={s.IconWrapper}>
          <Image
            width={22}
            height={22}
            src={`/img/${icon}.svg`}
            alt=""
            className={classNames(s.Icon, s.IconDefault)}
          />
          <Image
            width={22}
            height={22}
            src={`/img/${icon}.svg`}
            alt=""
            className={classNames(s.Icon, s.IconHover)}
          />
        </span>
      )}
      {children}
    </button>
  );
};

ButtonSecondary.propTypes = {};

export default ButtonSecondary;
